import React from 'react';

// Both colour states are set explicitly: as an <a>, Bootstrap's `a:hover` (0,1,1) would otherwise
// beat a plain tw-text-* class (0,1,0) and recolour the label on hover.
const CLASSES = 'tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-md tw-bg-brand-600 tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-brand-700 hover:tw-text-white focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-brand-300';

/** Brand-red header button. Renders an <a> when `href` is given, otherwise a <button>. */
const HeaderButton = ({ icon: Icon, href, onClick, children, ...rest }) => {
    const content = <>
        {Icon ? <Icon className="tw-h-4 tw-w-4" aria-hidden="true" /> : null}
        {children}
    </>;

    return href
        ? <a href={href} className={CLASSES} {...rest}>{content}</a>
        : <button type="button" onClick={onClick} className={CLASSES} {...rest}>{content}</button>;
};

export default HeaderButton;
